import { createContext, useContext } from 'react'
import { fileUrl } from '../../eventsPublic/functions/fileUrl'

// Adresse einer hochgeladenen Datei. Die oeffentliche Seite liest sie ueber
// matrixPublicParams; die Vorschau im Backoffice kennt nur matrixParams und
// gibt ihre eigene Adressbildung hinein (Spec 2026-10-05 Live-Vorschau).
export const FileUrlContext = createContext(fileUrl)

export const useFileUrl = () => useContext(FileUrlContext)
